import styled from 'styled-components';

import { ButtonCloseProps } from '.';

export const ButtonClose = styled.a<ButtonCloseProps>`
  position: relative;
  display: block;
  width: ${({ size }) => (size ? size : 23)}px;
  height: ${({ size }) => (size ? size : 23)}px;

  &::before,
  &::after {
    content: ' ';
    position: absolute;
    left: ${({ size }) => (size ? size / 2 : 11)}px;
    height: ${({ size }) => (size ? size - 1 : 22)}px;
    width: 2px;
    background-color: ${({ theme, color }) => (color ? color : theme.colors.gray800)};
  }
  &::before {
    transform: rotate(45deg);
  }
  &::after {
    transform: rotate(-45deg);
  }
`;
